// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"e51a9675","65":"42049b14","161":"bd060376","239":"124b4995","276":"360a139b","307":"309a83b5","325":"d360747a","351":"e7a3b97c","420":"90c3fb80","426":"9e28c3ac","496":"c1eb98de","746":"40ba4b1d","817":"dd4fb498","914":"09b0bae1","989":"130cb96c"}[chunkId] + ".chunk.js";
};